import * as React from 'react';
import { Outside } from '../../../services';
import * as styles from './styles.css';
export function SelectDropdown(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(Outside, {
    onOutside: onClose,
    active: true
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['dropdown']
  }, children));
}